export default {
  INSTAGRAM: 1,
  FACEBOOK: 2,
  WHATSAPP: 3,
  TELEPHONE: 4,
  TWITTER: 5,
  YOUTUBE: 6,
  TIKTOK: 7,
  EMAIL: 8,
};
